import React, { useState, useEffect } from 'react';
import {
    Box,
    Paper,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
    Divider,
    Alert,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Stepper,
    Step,
    StepLabel,
    StepContent,
    Checkbox,
    FormControlLabel,
    Tabs,
    Tab,
    RadioGroup,
    Radio
} from '@mui/material';
import {
    Payment as PaymentIcon,
    AccountBalance as BankIcon,
    CreditCard as CardIcon,
    Receipt as ReceiptIcon,
    Security as SecurityIcon,
    CheckCircle as CheckIcon,
    Warning as WarningIcon,
    Visibility as ViewIcon,
    ArrowBack as BackIcon,
    MoneyOff as OfflineIcon,
    Info as InfoIcon
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useNavigate, useLocation } from 'react-router-dom';
import authService from '../../services/authService';
import laboratoryService from '../../services/laboratoryService';
import feesService from '../../services/feesService';
import paymentService from '../../services/paymentService';
import { decryptText } from '../../utils/encryption';
import CalibrationFeesService from '../../services/CalibrationFeesService';



const PaymentPage = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get payment type from URL query string
    const searchParams = new URLSearchParams(location.search);

    const paymentTypefromUrl = searchParams.get('paymentType') || ''; // Default to application fees (2)
    const paymentType = decryptText(paymentTypefromUrl);
    const appIdFromUrl = searchParams.get('appId') || '';
    const decryptedAppId = decryptText(appIdFromUrl);

    // Get payment details from location state or localStorage
    const [appId, setAppId] = useState(decryptedAppId);
    const [paymentDetails, setPaymentDetails] = useState();
    const [activeStep, setActiveStep] = useState(0);
    const [paymentStatus, setPaymentStatus] = useState('pending');
    const [loading, setLoading] = useState(false);
    const [deductTDS, setDeductTDS] = useState(false);
    const [tanNumber, setTanNumber] = useState('');
    const [tanError, setTanError] = useState('');
    const [labBasicDetails, setLabBasicDetails] = useState(null);
    const [labDetailsLoading, setLabDetailsLoading] = useState(true);
    const [labDetailsError, setLabDetailsError] = useState(null);
    const [feesLoading, setFeesLoading] = useState(true);
    const [feesError, setFeesError] = useState(null);

    // Invoice data state for assessment Proforma invoice
    const [invoiceData, setInvoiceData] = useState(null);

    // GST exemption state
    const [gstExemptionData, setGstExemptionData] = useState(null);
    const [isGstExempted, setIsGstExempted] = useState(false);

    // Offline Payment States
    const [showBankDetails, setShowBankDetails] = useState(false);
    const [showOfflineForm, setShowOfflineForm] = useState(false);
    const [bankDetailsType, setBankDetailsType] = useState('government'); // 'government' or 'other'
    const [offlinePaymentData, setOfflinePaymentData] = useState({
        mode: '',
        referenceNumber: '',
        transactionDate: new Date(),
        remarks: ''
    });
    const [offlineSubmissionLoading, setOfflineSubmissionLoading] = useState(false);
    const [paymentMode, setPaymentMode] = useState('online'); // 'online' or 'offline'

    useEffect(() => {
        const init = async () => {
            fetchBasicDetails();
            checkRecentPayment();

            // GST exemption must resolve BEFORE fees so fetchFeesData gets correct status
            const exempted = await getGstExemption();
            fetchFeesData(exempted);

            const urlParams = new URLSearchParams(window.location.search);
            const paymentSuccess = urlParams.get('payment_success');
            const orderId = urlParams.get('order_id');
            if (paymentSuccess === 'true' && orderId) {
                setPaymentStatus('success');
                setActiveStep(2);
            } else if (paymentSuccess === 'false') {
                setPaymentStatus('failed');
            }
        };
        init();
    }, [navigate, paymentType]);

    const checkRecentPayment = async () => {
        try {
            const paymentCompletion = await paymentService.checkPaymentCompletion();
            if (paymentCompletion.isCompleted) {
                setPaymentStatus('success');
                setActiveStep(2);

            }
        } catch (error) {
            console.error('Error checking recent payment:', error);
        }
    };

    const LoadassessmentPerformaInvoice = async () => {
        try {
            const response = await feesService.getAssessmentPerformaInvoice(appId);


            if (response.status === 'success' && response.data && response.data.invoiceData) {
                setInvoiceData(response.data.invoiceData);

            } else {
                console.warn('No invoice data found in response:', response);
                setInvoiceData(null);
            }
        } catch (error) {
            console.error('Error loading assessment Proforma invoice:', error);
            setInvoiceData(null);
        }
    };

    useEffect(() => {
        if (paymentType === '7') {
            LoadassessmentPerformaInvoice();
        }
    }, [paymentType]);

    const fetchFeesData = async (gstExempted = isGstExempted) => {
        try {
            setFeesLoading(true);
            setFeesError(null);

            // Get AppId from localStorage
            let response;

            // Call different APIs based on paymentType
            if (paymentType === '7') {
                // Annual accreditation fees
                response = await feesService.getAnnualAccreditationFees(appId);

            } else if (paymentType === '2') {

                if (localStorage.getItem('labTypeId') !== '3') {
                    // Application fees (default)
                    const appresponse = await fetch(`${process.env.REACT_APP_API_URL}/laboratory/application-stage/${appId}`);
                    const stageResult = await appresponse.json();
                    if (!stageResult.success || !stageResult.assessmentTypeId) {
                        throw new Error('Unable to fetch assessment type. Please try again.');
                    }
                    if ([5, 8, 9, 10, 11, 12, 13, 17].includes(stageResult.assessmentTypeId)) {
                        response = await feesService.getFeesByAppIdAndAssessmentTypeId(appId, stageResult.labTypeId);
                    } else {
                        response = await CalibrationFeesService.getFeesByAppId(appId);
                    }
                }
                else {
                    // Application fees (default)
                    const appresponse = await fetch(`${process.env.REACT_APP_API_URL}/laboratory/application-stage/${appId}`);
                    const stageResult = await appresponse.json();
                    if (!stageResult.success || !stageResult.assessmentTypeId) {
                        throw new Error('Unable to fetch assessment type. Please try again.');
                    }
                    if ([5, 8, 9, 10, 11, 12, 13, 17].includes(stageResult.assessmentTypeId)) {
                        response = await feesService.getFeesByAppIdAndAssessmentTypeId(appId, stageResult.labTypeId);
                    } else {
                        response = await feesService.getFeesByAppId(appId);
                    }
                }


            } else if (paymentType === '6') {
                // Application fees (default)
                response = await feesService.getAssessmentFeesByAppId(appId);

            } else {
                // For other payment types, default to application fees
                const appresponse = await fetch(`${process.env.REACT_APP_API_URL}/laboratory/application-stage/${appId}`);
                const stageResult = await appresponse.json();
                if (!stageResult.success || !stageResult.assessmentTypeId) {
                    throw new Error('Unable to fetch assessment type. Please try again.');
                }
                if ([5, 8, 9, 10, 11, 12, 13, 17].includes(stageResult.assessmentTypeId)) {
                    response = await feesService.getFeesByAppIdAndAssessmentTypeId(appId, stageResult.labTypeId);
                } else {
                    response = await feesService.getFeesByAppId(appId);
                }
            }

            if (response.status === 'success' && response.data) {
                // Process fees data from your API response format
                const feesBreakdown = response.data.feesBreakdown || [];

                // Convert string fees to numbers and ensure proper structure
                const processedFeesBreakdown = feesBreakdown.map(item => ({
                    ...item,
                    fees: parseInt(item.fees) || 0 // Convert string to number
                }));

                // Use the summary from API response (already calculated)
                let summary = response.data.summary || {
                    grossTotal: 0,
                    gstAmount: 0,
                    gstRate: 18,
                    grandTotal: 0
                };

                // Apply GST exemption if approved — use param, not stale closure state
                if (gstExempted) {
                    summary = {
                        ...summary,
                        gstAmount: 0,
                        grandTotal: summary.grossTotal // Grand total becomes equal to gross total when GST is exempted
                    };
                }

                setPaymentDetails({
                    appId: response.data.appId || appId,
                    feesBreakdown: processedFeesBreakdown,
                    summary: summary,
                    cabType: response.data.cabType,
                    hasMedicalImaging: response.data.hasMedicalImaging,
                    paymentType: paymentType,
                    paymentTypeDescription: paymentType === '7' ? 'Annual Accreditation Fees' : 'Application Fees',
                    laboratoryName: response.data.laboratoryName
                });

            } else {
                throw new Error(response.message || 'Failed to fetch fees data');
            }
        } catch (error) {
            console.error('Error fetching fees data:', error);
            setFeesError(error.message);
        } finally {
            setFeesLoading(false);
        }
    };
    const getGstExemption = async () => {
        try {
            const response = await feesService.getGstExemption(appId);

            if (response.status === 'success' && response.data && response.data.gstData) {
                const gstData = response.data.gstData;
                setGstExemptionData(gstData);
                const exempted = gstData.isapproved === 1;
                setIsGstExempted(exempted);
                return exempted;
            } else {
                setGstExemptionData(null);
                setIsGstExempted(false);
                return false;
            }
        } catch (error) {
            console.error('Error fetching GST exemption:', error);
            setGstExemptionData(null);
            setIsGstExempted(false);
            return false;
        }
    };

    // Re-apply GST exemption when exemption status changes
    useEffect(() => {
        if (paymentDetails && paymentDetails.summary) {
            let updatedSummary = { ...paymentDetails.summary };

            if (isGstExempted) {
                // Remove GST if exempted
                updatedSummary = {
                    ...updatedSummary,
                    gstAmount: 0,
                    grandTotal: updatedSummary.grossTotal
                };

            } else if (updatedSummary.grossTotal > 0 && updatedSummary.gstAmount === 0) {
                // Re-calculate GST if not exempted and GST was previously removed
                const gstRate = updatedSummary.gstRate || 18;
                const gstAmount = (updatedSummary.grossTotal * gstRate) / 100;
                updatedSummary = {
                    ...updatedSummary,
                    gstAmount: gstAmount,
                    grandTotal: updatedSummary.grossTotal + gstAmount
                };

            }

            setPaymentDetails(prevDetails => ({
                ...prevDetails,
                summary: updatedSummary
            }));
        }
    }, [isGstExempted]);

    const fetchBasicDetails = async () => {
        try {
            setLabDetailsLoading(true);
            setLabDetailsError(null);

            const response = await laboratoryService.getPaymentBasicDetail(appId);

            if (response.success && response.data) {
                setLabBasicDetails({
                    LaboratoryName: response.data.CabName || 'N/A',
                    ContactEmail: response.data.ContactEmail || response.data.Email || 'N/A',
                    ContactMobile: response.data.ContactPersonMobileNo || response.data.ContactPersonMobileNo || 'N/A',
                    OrgId: response.data.OrgId || 'N/A',
                    AppId: response.data.AppId || appId,
                    Address: response.data.Address || response.data.AddressLine1 || 'N/A',
                    City: response.data.CityName || 'N/A',
                    State: response.data.stateName || 'N/A',
                    LaboratoryType: response.data.LaboratoryType || 'Medical Laboratory',
                    GSTNumber: response.data.GSTNumber || '',
                    ContactPerson: response.data.ContactPerson || '',
                    TAN: response.data.TAN || '',
                    LegalIdentityType: response.data.LegalIdentityType || '',
                    Pincode: response.data.Pincode || response.data.Pin || ''
                });

            } else {
                throw new Error(response.message || 'Failed to fetch basic details');
            }
        } catch (error) {
            console.error('Error fetching basic details:', error);
            setLabDetailsError(error.message);
        } finally {
            setLabDetailsLoading(false);
        }
    };

    const formatCurrency = (amount) => {
        if (!amount) return '₹0.00';
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount);
    };

    const calculateTDSAmount = () => {
        if (!deductTDS || !paymentDetails?.summary) return 0;
        // Simple TDS calculation: 2% of gross total
        return (paymentDetails.summary.grossTotal * 2) / 100;
    };

    const getFinalAmount = () => {
        if (!paymentDetails?.summary) return 0;
        const totalAmount = paymentDetails.summary.grandTotal;
        const tdsAmount = calculateTDSAmount();
        return totalAmount - tdsAmount;
    };

    const processPayment = async () => {
        setLoading(true);
        try {
            // Get current user session
            const userSession = authService.getUserData();
            if (!userSession) {
                throw new Error('User session not found. Please login again.');
            }

            // Validate TDS requirements
            if (deductTDS && !tanNumber.trim()) {
                throw new Error('TAN number is required when TDS is selected');
            }
            if (deductTDS && !/^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumber)) {
                setTanError('Invalid TAN format (e.g., ABCD12345E)');
                throw new Error('Invalid TAN format. Required: 4 letters + 5 digits + 1 letter (e.g., ABCD12345E)');
            }

            // Show processing status
            setPaymentStatus('processing');

            // Prepare payment data for ICICI gateway
            const finalAmount = deductTDS ? getFinalAmount() : paymentDetails?.summary?.grandTotal || 0;
            const paymentData = {
                CustomerID: userSession.orgId || labBasicDetails?.OrgId,
                TxnAmount: finalAmount,
                BankReferenceNo: `NABL${Date.now()}`,
                Description: 'NABL Accreditation Application Fee',
                email: labBasicDetails?.ContactEmail || userSession.email,
                phone: labBasicDetails?.ContactMobile || userSession.mobile,
                laboratoryName: labBasicDetails?.LaboratoryName,
                applicationNo: labBasicDetails?.AppId || paymentDetails?.appId,
                orgId: userSession.orgId || labBasicDetails?.OrgId,
                appId: labBasicDetails?.AppId || paymentDetails?.appId,
                paymentType: '2', // Application fee
                tdsDeducted: deductTDS,
                tdsAmount: deductTDS ? calculateTDSAmount() : 0,
                tan: tanNumber,
                userName: localStorage.getItem('username') || userSession.name
            };



            // Call our ICICI payment API using the payment service
            const apiPaymentData = {
                appId: labBasicDetails?.AppId || appId || '',
                orgId: userSession.orgId || labBasicDetails?.OrgId,
                paymentTypeId: paymentType, // Use paymentType from URL
                amount: paymentDetails?.summary?.grossTotal || 0,
                gstAmount: paymentDetails?.summary?.gstAmount || 0,
                totalAmount: finalAmount,
                currency: 'INR',
                email: labBasicDetails?.ContactEmail || userSession.email,
                mobile: labBasicDetails?.ContactMobile || userSession.mobile,
                labTypeId: '1', // Medical laboratory
                chkDeductTds: deductTDS,
                TDSAmount: deductTDS ? calculateTDSAmount() : 0,
                TDSPercent: deductTDS ? 2 : 0,
                tan: tanNumber,
                userName: localStorage.getItem('username') || userSession.name
            };



            // Use the payment service to initiate ICICI payment
            const result = await paymentService.initiateICICIPayment(apiPaymentData);

            if (result.success && result.data && result.data.paymentUrl) {


                // Store payment information for tracking
                localStorage.setItem('currentOrderId', result.data.orderId);
                localStorage.setItem('paymentInitiated', JSON.stringify({
                    orderId: result.data.orderId,
                    amount: result.data.amount,
                    appId: apiPaymentData.appId,
                    orgId: apiPaymentData.orgId,
                    timestamp: new Date().toISOString()
                }));

                // Show success message before redirect
                setPaymentStatus('redirecting');

                // Small delay to show the status, then redirect
                setTimeout(() => {
                    window.location.href = result.data.paymentUrl;
                }, 1000);

                return;
            } else {
                throw new Error(result.message || 'Failed to generate payment URL from server');
            }

        } catch (error) {
            console.error('Payment processing error:', error);
            setPaymentStatus('failed');

            // Show error message
            let errorMessage = `Payment processing failed: ${error.message}`;

            if (error.message.includes('session')) {
                errorMessage += '\n\nPlease login again and retry.';
            } else if (error.message.includes('TAN')) {
                errorMessage += '\n\nPlease provide a valid TAN number for TDS deduction.';
            } else if (error.message.includes('gateway')) {
                errorMessage += '\n\nPlease check your internet connection and try again.';
            }

            alert(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    // Offline Payment Handlers
    const handleOfflinePaymentSubmit = async () => {
        if (!offlinePaymentData.mode || !offlinePaymentData.referenceNumber || !offlinePaymentData.transactionDate) {
            alert('Please fill all required fields');
            return;
        }

        setOfflineSubmissionLoading(true);
        try {
            const userSession = authService.getUserData();
            const submissionData = {
                orgId: userSession.orgId || labBasicDetails?.OrgId,
                appId: labBasicDetails?.AppId || appId || '',
                paymentTypeId: paymentType, // Use paymentType from URL
                mode: offlinePaymentData.mode,
                referenceNumber: offlinePaymentData.referenceNumber,
                transactionDate: offlinePaymentData.transactionDate,
                remarks: offlinePaymentData.remarks,
                amount: paymentDetails?.summary?.grandTotal || 0
            };



            // Call API to save offline payment details
            const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000/reactApi/api'}/accounts/offline-payment-form/submit-offline-payment`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
                },
                body: JSON.stringify(submissionData)
            });

            const result = await response.json();

            if (response.ok && result.success) {
                alert('Offline payment details submitted successfully! Payment will be updated within 24 hours (Working days).');
                setShowOfflineForm(false);
                // Reset form
                setOfflinePaymentData({
                    mode: '',
                    referenceNumber: '',
                    transactionDate: new Date(),
                    remarks: ''
                });
            } else {
                throw new Error(result.message || 'Failed to submit offline payment details');
            }
        } catch (error) {
            console.error('Error submitting offline payment:', error);
            alert('Error submitting offline payment details: ' + error.message);
        } finally {
            setOfflineSubmissionLoading(false);
        }
    };

    const getVirtualAccountNumber = () => {
        const userSession = authService.getUserData();
        const usernamefromlocal = localStorage.getItem('username');

        const orgId = userSession?.username || usernamefromlocal || '';

        // Remove 'nabln' and keep only number
        const finishOrgId = orgId.replace(/^(nabln|nabl)/, '');

        return `NABLQC${finishOrgId}`;
    };

    const steps = [
        'Review Payment Details',
        'Verify & Pay',
        'Payment Confirmation'
    ];
    const handlePerformaInvoice = () => {
        const orgId = localStorage.getItem('orgId');

        const previewUrl = `https://nablwpnew.qci.org.in/InvoiceApplicationPerfomaQR?appId=${appId}&payType=${paymentType}`;

        // Open in new tab/window
        window.open(previewUrl, '_blank');

    };
    const handlePerformaInvoiceAssessment = async () => {
        const orgId = localStorage.getItem('orgId');

        // If invoice data is not loaded yet, try to load it first
        let currentInvoiceData = invoiceData;
        if (!currentInvoiceData && paymentType === '7') {

            try {
                const response = await feesService.getAssessmentPerformaInvoice(appId);
                if (response.status === 'success' && response.data && response.data.invoiceData) {
                    currentInvoiceData = response.data.invoiceData;
                    setInvoiceData(currentInvoiceData); // Update state for future use

                }
            } catch (error) {
                console.warn('Failed to load invoice data, proceeding without ID:', error);
            }
        }

        // Get invoice data ID if available
        const invoiceId = currentInvoiceData?.Id || '';

        // Build URL with invoice ID if available
        let previewUrl = `https://nablwpnew.qci.org.in/InvoiceAAFEEPerforma?appId=${appId}&payType=${paymentType}&Form11=1&OrgId=${orgId}`;
        if (invoiceId) {
            previewUrl += `&id=${invoiceId}`;
        }


        // Open in new tab/window
        window.open(previewUrl, '_blank');

    };

    // Render lab basic details section
    const renderLabDetails = () => (
        <Card elevation={2} sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                    <SecurityIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Laboratory Information
                </Typography>

                {labDetailsLoading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" color="text.secondary">
                            Loading laboratory details...
                        </Typography>
                    </Box>
                ) : labDetailsError ? (
                    <Alert severity="warning" sx={{ mt: 1 }}>
                        <Typography variant="body2">
                            Could not load laboratory details: {labDetailsError}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            Using fallback data for payment processing.
                        </Typography>
                    </Alert>
                ) : labBasicDetails ? (
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">
                                Laboratory Name
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                {labBasicDetails.LaboratoryName}
                            </Typography>
                        </Grid>

                        {/* <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">
                                Organization ID
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                {labBasicDetails.OrgId}
                            </Typography>
                        </Grid> */}

                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">
                                Contact Email
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                {labBasicDetails.ContactEmail || labBasicDetails.ContactPersonEmail2 || 'Not provided'}
                            </Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <Typography variant="body2" color="text.secondary">
                                Contact Mobile
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                {labBasicDetails.ContactMobile || 'Not provided'}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">
                                Address
                            </Typography>
                            <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                {labBasicDetails.Address ||
                                    [labBasicDetails.AddressLine1, labBasicDetails.AddressLine2].filter(Boolean).join(', ') ||
                                    'Address not provided'}
                                {(labBasicDetails.Pincode || labBasicDetails.Pin) && ` - ${labBasicDetails.Pincode || labBasicDetails.Pin}`}
                            </Typography>
                        </Grid>

                        {(labBasicDetails.State || labBasicDetails.City) && (
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Location
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    {[labBasicDetails.City, labBasicDetails.State].filter(Boolean).join(', ')}
                                </Typography>
                            </Grid>
                        )}

                        {labBasicDetails.LaboratoryType && (
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Laboratory Type
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    {labBasicDetails.LaboratoryType}
                                </Typography>
                            </Grid>
                        )}

                        {labBasicDetails.GSTNumber && (
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" color="text.secondary">
                                    GST Number
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    {labBasicDetails.GSTNumber}
                                </Typography>
                            </Grid>
                        )}

                        {labBasicDetails.ContactPerson && (
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" color="text.secondary">
                                    Contact Person
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    {labBasicDetails.ContactPerson}
                                </Typography>
                            </Grid>
                        )}

                        {labBasicDetails.TAN && (
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2" color="text.secondary">
                                    TAN Number
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'medium', mb: 1 }}>
                                    {labBasicDetails.TAN}
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                ) : (
                    <Alert severity="info" sx={{ mt: 1 }}>
                        Using sample laboratory details for demonstration.
                    </Alert>
                )}
            </CardContent>
        </Card>
    );

    const renderPaymentSummary = () => (
        <Card elevation={2} sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                    <ReceiptIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Payment Summary - {paymentDetails?.paymentTypeDescription || 'Application Fees'}
                    {paymentDetails?.cabType && (
                        <Chip
                            label={paymentDetails.cabType}
                            size="small"
                            sx={{ ml: 2 }}
                            color="info"
                        />
                    )}
                </Typography>

                {feesLoading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            Loading fees information...
                        </Typography>
                    </Box>
                ) : feesError ? (
                    <Alert severity="warning" sx={{ mb: 2 }}>
                        <Typography variant="body2">
                            Could not load fees data: {feesError}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            Using fallback data for payment processing.
                        </Typography>
                    </Alert>
                ) : (
                    <>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            <Typography variant="body2" fontWeight="bold">
                                Payment Type: {paymentDetails?.paymentTypeDescription || 'Application Fees'}
                            </Typography>
                            {paymentDetails?.laboratoryName && (
                                <Typography variant="body2">
                                    Laboratory: {paymentDetails.laboratoryName}
                                </Typography>
                            )}
                            {isGstExempted && (
                                <Typography variant="body2" sx={{ color: 'success.main', fontWeight: 'bold' }}>
                                    ✓ GST Exemption Applied - No GST will be charged
                                </Typography>
                            )}
                        </Alert>
                        {paymentDetails?.hasMedicalImaging !== undefined && (
                            <Alert severity="info" sx={{ mb: 2 }}>
                                <Typography variant="body2">
                                    Medical Imaging: {paymentDetails.hasMedicalImaging ? 'Yes' : 'No'}
                                </Typography>
                            </Alert>
                        )}
                    </>
                )}

                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Description</TableCell>
                                <TableCell>Fee Type</TableCell>
                                <TableCell align="right">Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paymentDetails?.feesBreakdown?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.category}</TableCell>
                                    <TableCell>
                                        <Chip
                                            label={item.FeeType || 'Standard'}
                                            size="small"
                                            color="secondary"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell align="right">{formatCurrency(item.fees)}</TableCell>
                                </TableRow>
                            ))}

                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold' }}>Gross Total</TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                                    {formatCurrency(paymentDetails?.summary?.grossTotal)}
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell>
                                    GST ({paymentDetails?.summary?.gstRate || 18}%)
                                    {isGstExempted && (
                                        <Chip
                                            label="EXEMPTED"
                                            size="small"
                                            color="success"
                                            sx={{ ml: 1 }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right" sx={{ color: isGstExempted ? 'success.main' : 'error.main' }}>
                                    {formatCurrency(paymentDetails?.summary?.gstAmount)}
                                    {isGstExempted && (
                                        <Typography variant="caption" sx={{ display: 'block', color: 'success.main' }}>
                                            (Exempted)
                                        </Typography>
                                    )}
                                </TableCell>
                            </TableRow>

                            {deductTDS && (
                                <TableRow>
                                    <TableCell>TDS (2%)</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right" sx={{ color: 'warning.main' }}>
                                        -{formatCurrency(calculateTDSAmount())}
                                    </TableCell>
                                </TableRow>
                            )}

                            <TableRow sx={{ backgroundColor: 'primary.light' }}>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1em' }}>
                                    {deductTDS ? 'Final Amount (After TDS)' : 'Grand Total'}
                                </TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', fontSize: '1.1em', color: 'white' }}>
                                    {formatCurrency(deductTDS ? getFinalAmount() : paymentDetails?.summary?.grandTotal)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );

    const renderBankDetailsDialog = () => (
        <Dialog open={showBankDetails} onClose={() => setShowBankDetails(false)} maxWidth="md" fullWidth>
            <DialogTitle>
                <BankIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                Bank Details for Offline Payment
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mb: 3 }}>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        If you are a government lab and wish to make payment through PFMS, please{' '}
                        <Button
                            variant="text"
                            onClick={() => setBankDetailsType('government')}
                            sx={{ textDecoration: 'underline', p: 0, minWidth: 'auto' }}
                        >
                            click here
                        </Button>
                        {' '}for bank details
                    </Typography>
                    <Typography variant="body1">
                        In case of other modes, please{' '}
                        <Button
                            variant="text"
                            onClick={() => setBankDetailsType('other')}
                            sx={{ textDecoration: 'underline', p: 0, minWidth: 'auto' }}
                        >
                            click here
                        </Button>
                        {' '}for bank details
                    </Typography>
                </Box>

                {bankDetailsType === 'government' && (
                    <Card sx={{ mb: 2 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom color="primary">Government Lab - PFMS Payment Details</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Name:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">Quality Council of India</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Bank Name:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">ICICI Bank</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Branch:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">MILLENIUM PLAZA GURGAON</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Account Number:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">739301000237</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">IFSC Code:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">ICIC0005391</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Type of Account:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">Saving Account</Typography></Grid>
                            </Grid>
                            <Alert severity="info" sx={{ mt: 2 }}>
                                After making payment, UTR details shall be entered at the portal using offline payment functionality given at your dashboard to get the payment updated in your account.
                            </Alert>
                        </CardContent>
                    </Card>
                )}

                {bankDetailsType === 'other' && (
                    <Card sx={{ mb: 2 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom color="primary">Other Payment Modes - Bank Details</Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Beneficiary Name:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">Quality Council of India</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Bank Name:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">HDFC Bank</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Branch:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">Kanjurmarg Branch, Mumbai</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">IFSC Code:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">HDFC0004989</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Virtual Account Number:</Typography></Grid>
                                <Grid item xs={6}>
                                    <Typography variant="body2" fontWeight="bold" color="primary">
                                        {getVirtualAccountNumber()}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6}><Typography variant="body2" fontWeight="bold">Type of Account:</Typography></Grid>
                                <Grid item xs={6}><Typography variant="body2">Saving Account</Typography></Grid>
                            </Grid>
                            <Alert severity="info" sx={{ mt: 2 }}>
                                After making payment, Virtual Account number shall be entered at the portal using offline payment functionality given at your dashboard to get the payment updated in your account.
                            </Alert>
                        </CardContent>
                    </Card>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowBankDetails(false)}>Close</Button>
            </DialogActions>
        </Dialog>
    );

    const renderOfflinePaymentDialog = () => (
        <Dialog open={showOfflineForm} onClose={() => setShowOfflineForm(false)} maxWidth="sm" fullWidth>
            <DialogTitle>
                <OfflineIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                Offline Payment Details
            </DialogTitle>
            <DialogContent>
                <Box sx={{ pt: 2 }}>
                    <FormControl fullWidth sx={{ mb: 3 }}>
                        <InputLabel>Select Mode *</InputLabel>
                        <Select
                            value={offlinePaymentData.mode}
                            label="Select Mode *"
                            onChange={(e) => setOfflinePaymentData(prev => ({ ...prev, mode: e.target.value }))}
                        >
                            <MenuItem value="">--Select--</MenuItem>
                            <MenuItem value="HDFC SmartHub">HDFC SmartHub</MenuItem>
                            <MenuItem value="Virtual Account">Virtual Account</MenuItem>
                            <MenuItem value="Direct NEFT/RTGS">Direct NEFT/RTGS</MenuItem>
                        </Select>
                    </FormControl>

                    {offlinePaymentData.mode && (
                        <TextField
                            fullWidth
                            label={
                                offlinePaymentData.mode === 'HDFC SmartHub' ? 'HDFC Payment ID *' :
                                    offlinePaymentData.mode === 'Virtual Account' ? 'Virtual Account Number *' :
                                        offlinePaymentData.mode === 'Direct NEFT/RTGS' ? 'UTR Number *' :
                                            'Reference Number *'
                            }
                            value={offlinePaymentData.referenceNumber}
                            onChange={(e) => setOfflinePaymentData(prev => ({ ...prev, referenceNumber: e.target.value }))}
                            sx={{ mb: 3 }}
                            required
                        />
                    )}

                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Transaction Date *"
                            value={offlinePaymentData.transactionDate}
                            onChange={(newDate) => setOfflinePaymentData(prev => ({ ...prev, transactionDate: newDate }))}
                            renderInput={(params) => <TextField {...params} fullWidth sx={{ mb: 3 }} required />}
                        />
                    </LocalizationProvider>

                    <TextField
                        fullWidth
                        label="Remarks"
                        multiline
                        rows={3}
                        value={offlinePaymentData.remarks}
                        onChange={(e) => setOfflinePaymentData(prev => ({ ...prev, remarks: e.target.value }))}
                        sx={{ mb: 3 }}
                    />

                    <Alert severity="success" sx={{ mb: 2 }}>
                        Payment will be updated within 24 hours (Working days).
                    </Alert>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setShowOfflineForm(false)}>Cancel</Button>
                <Button
                    variant="contained"
                    onClick={handleOfflinePaymentSubmit}
                    disabled={offlineSubmissionLoading}
                >
                    {offlineSubmissionLoading ? 'Submitting...' : 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );

    const renderPaymentForm = () => (
        <Card elevation={2} sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant="h6" gutterBottom sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                    <PaymentIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
                    Payment Options
                </Typography>

                {/* Payment Mode Selection */}
                <Box sx={{ mb: 3 }}>
                    <Typography variant="subtitle1" gutterBottom>Choose Payment Mode:</Typography>
                    <RadioGroup
                        row
                        value={paymentMode}
                        onChange={(e) => setPaymentMode(e.target.value)}
                    >
                        <FormControlLabel value="online" control={<Radio />} label="Online Payment (ICICI Gateway)" />
                        {labBasicDetails.LegalIdentityType === 'Government' && (
                            <FormControlLabel value="offline" control={<Radio />} label="Offline Payment" />
                        )}
                    </RadioGroup>
                </Box>

                {paymentMode === 'online' ? (
                    <>
                        <Alert severity="info" sx={{ mb: 3 }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                ICICI EasyPay Production Gateway
                            </Typography>
                            <Typography variant="body2">
                                You will be redirected to the secure ICICI payment gateway to complete your transaction.
                                We support multiple payment methods including Credit/Debit Cards, Net Banking, and UPI.
                            </Typography>
                        </Alert>

                        {paymentStatus === 'processing' && (
                            <Alert severity="warning" sx={{ mb: 3 }}>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    Connecting to ICICI Payment Gateway...
                                </Typography>
                                <Typography variant="body2">
                                    Please wait while we process your payment request and prepare the secure gateway connection.
                                </Typography>
                            </Alert>
                        )}

                        {paymentStatus === 'redirecting' && (
                            <Alert severity="success" sx={{ mb: 3 }}>
                                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                    Redirecting to ICICI EasyPay Gateway...
                                </Typography>
                                <Typography variant="body2">
                                    Payment URL generated successfully. You will be redirected to the secure payment gateway in a moment.
                                    Do not close this window or press the back button.
                                </Typography>
                            </Alert>
                        )}

                        {/* TDS Deduction Option */}
                        <Box sx={{ p: 2, backgroundColor: 'warning.50', borderRadius: 1, mb: 3 }}>
                            {/* <Typography variant="h6" gutterBottom>No TDS Deduction Applicable</Typography> */}
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={deductTDS}
                                        onChange={(e) => setDeductTDS(e.target.checked)}
                                        color="warning"
                                    />
                                }
                                label="Deduct TDS (2%)"
                            />

                            {deductTDS && (
                                <Box sx={{ mt: 2 }}>
                                    <TextField
                                        fullWidth
                                        label="TAN Number"
                                        value={tanNumber}
                                        onChange={(e) => {
                                            const val = e.target.value.toUpperCase();
                                            setTanNumber(val);
                                            if (val && !/^[A-Z]{4}[0-9]{5}[A-Z]$/.test(val)) {
                                                setTanError('Invalid TAN format (e.g., ABCD12345E)');
                                            } else {
                                                setTanError('');
                                            }
                                        }}
                                        variant="outlined"
                                        size="small"
                                        required
                                        error={!!tanError}
                                        helperText={tanError || "4 letters + 5 digits + 1 letter (e.g., ABCD12345E)"}
                                        placeholder="e.g., ABCD12345E"
                                        inputProps={{ maxLength: 10 }}
                                    />
                                    <Alert severity="info" sx={{ mt: 1 }}>
                                        TDS Amount: {formatCurrency(calculateTDSAmount())}<br />
                                        Final Amount: {formatCurrency(getFinalAmount())}
                                    </Alert>
                                </Box>
                            )}
                        </Box>

                        {/* Payment Summary */}
                        <Box sx={{ mt: 3, p: 2, backgroundColor: 'primary.50', borderRadius: 1 }}>
                            <Typography variant="h6" gutterBottom>Final Payment Amount</Typography>
                            <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                                {formatCurrency(deductTDS ? getFinalAmount() : paymentDetails?.summary?.grandTotal)}
                            </Typography>
                            {deductTDS && (
                                <Typography variant="body2" color="text.secondary">
                                    (After TDS deduction of {formatCurrency(calculateTDSAmount())})
                                </Typography>
                            )}
                        </Box>
                    </>
                ) : (
                    <Box>
                        <Alert severity="info" sx={{ mb: 3 }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                                Offline Payment Options
                            </Typography>
                            <Typography variant="body2">
                                Choose from bank transfer, NEFT/RTGS, or other offline payment methods.
                                Payment will be updated within 24 hours (working days).
                            </Typography>
                        </Alert>

                        <Grid container spacing={2} sx={{ mb: 3 }}>
                            <Grid item xs={12} sm={6}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<BankIcon />}
                                    onClick={() => setShowBankDetails(true)}
                                    sx={{ height: '60px', textAlign: 'center' }}
                                >
                                    <Box>
                                        <Typography variant="body2" fontWeight="bold">Bank Details</Typography>
                                        <Typography variant="caption">for offline payment</Typography>
                                    </Box>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Button
                                    variant="outlined"
                                    fullWidth
                                    startIcon={<OfflineIcon />}
                                    onClick={() => setShowOfflineForm(true)}
                                    sx={{ height: '60px', textAlign: 'center' }}
                                >
                                    <Box>
                                        <Typography variant="body2" fontWeight="bold">Fill Payment Details</Typography>
                                        <Typography variant="caption">update offline payment info</Typography>
                                    </Box>
                                </Button>
                            </Grid>
                        </Grid>

                        <Alert severity="warning" sx={{ mb: 2 }}>
                            <Typography variant="body2">
                                <strong>Important:</strong> After making the offline payment, please use the "Fill Payment Details"
                                option to provide your transaction details for payment verification.
                            </Typography>
                        </Alert>
                    </Box>
                )}
            </CardContent>
        </Card>
    );

    const renderPaymentConfirmation = () => (
        <Card elevation={2} sx={{ mb: 3, textAlign: 'center' }}>
            <CardContent>
                {paymentStatus === 'success' ? (
                    <>
                        <CheckIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                        <Typography variant="h5" gutterBottom sx={{ color: 'success.main', fontWeight: 'bold' }}>
                            Payment Successful!
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Your payment of {formatCurrency(paymentDetails?.summary?.grandTotal)} has been processed successfully.
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                            Transaction ID: TXN{Date.now()}
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => navigate('/main/medical/declaration')}
                            sx={{ mr: 2 }}
                        >
                            Continue to Application
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={() => window.print()}
                        >
                            Print Receipt
                        </Button>
                    </>
                ) : (
                    <>
                        <WarningIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
                        <Typography variant="h5" gutterBottom sx={{ color: 'error.main', fontWeight: 'bold' }}>
                            Payment Failed
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 3 }}>
                            There was an issue processing your payment. Please try again.
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setActiveStep(1);
                                setPaymentStatus('pending');
                            }}
                            color="error"
                        >
                            Retry Payment
                        </Button>
                    </>
                )}
            </CardContent>
        </Card>
    );

    if (feesLoading || labDetailsLoading) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="h6" gutterBottom>Loading Payment Information...</Typography>
                <Typography variant="body2" color="text.secondary">
                    Please wait while we fetch your fees and laboratory details.
                </Typography>
            </Box>
        );
    }

    if (!paymentDetails) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Alert severity="error">
                    <Typography variant="h6" gutterBottom>Payment Details Not Found</Typography>
                    <Typography>Please return to the fees page to proceed with payment.</Typography>
                    <Button
                        variant="contained"
                        onClick={() => navigate(-1)}
                        sx={{ mt: 2 }}
                    >
                        Go to Fees Page
                    </Button>
                </Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3, mt: 5, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
            {/* Header */}
            <Paper sx={{ p: 3, mb: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    {/* <Button
                        startIcon={<BackIcon />}
                        onClick={() => navigate('/main/medical/declaration')}
                        sx={{ mr: 2 }}
                    >
                        Back
                    </Button> */}
                    <Typography variant="h4" sx={{ color: 'primary.main', fontWeight: 'bold' }}>
                        Payment Gateway
                    </Typography>
                </Box>

                <Typography variant="subtitle1" color="text.secondary">
                    Complete your payment for NABL Accreditation - {paymentDetails?.paymentTypeDescription || 'Application Fees'}
                </Typography>

                <Box sx={{ display: 'flex', alignItems: 'center', mt: 2, gap: 1 }}>
                    <SecurityIcon sx={{ color: 'success.main' }} />
                    <Typography variant="body2" color="success.main">
                        Secure Payment Gateway
                    </Typography>
                </Box>
            </Paper>

            {/* Stepper */}
            <Paper sx={{ p: 3, mb: 3 }}>
                <Stepper activeStep={activeStep} orientation="horizontal">
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Paper>

            <Grid container spacing={3}>
                <Grid item xs={12} lg={8}>
                    {/* Payment Content */}
                    {activeStep === 0 && (
                        <>
                            {renderLabDetails()}
                            {renderPaymentSummary()}
                            <Box sx={{ textAlign: 'center' }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    sx={{ mr: 2 }}
                                    onClick={() => setActiveStep(1)}
                                >
                                    Proceed to Payment
                                </Button>
                                {paymentType === '2' ? (
                                    <Button
                                        variant="outlined"
                                        startIcon={<ViewIcon />}
                                        onClick={handlePerformaInvoice}
                                        disabled={loading}
                                        size="large"
                                        color="secondary"
                                        sx={{
                                            borderColor: 'secondary.main',
                                            '&:hover': {
                                                borderColor: 'secondary.dark',
                                                backgroundColor: 'secondary.50'
                                            }
                                        }}
                                    >
                                        Proforma Invoice
                                    </Button>
                                ) : paymentType === '7' ? (
                                    <Button
                                        variant="outlined"
                                        startIcon={<ViewIcon />}
                                        onClick={handlePerformaInvoiceAssessment}
                                        disabled={loading}
                                        size="large"
                                        color="secondary"
                                        sx={{
                                            borderColor: 'secondary.main',
                                            '&:hover': {
                                                borderColor: 'secondary.dark',
                                                backgroundColor: 'secondary.50'
                                            }
                                        }}
                                    >
                                        Proforma Invoice
                                    </Button>
                                ) : null}

                            </Box>
                        </>
                    )}

                    {activeStep === 1 && (
                        <>
                            {renderPaymentForm()}
                            <Box sx={{ textAlign: 'center', display: 'flex', gap: 2, justifyContent: 'center' }}>
                                <Button
                                    variant="outlined"
                                    onClick={() => setActiveStep(0)}
                                    disabled={loading}
                                >
                                    Back
                                </Button>
                                {paymentMode === 'online' ? (
                                    <Button
                                        variant="contained"
                                        size="large"
                                        onClick={processPayment}
                                        disabled={loading || paymentStatus === 'processing' || paymentStatus === 'redirecting'}
                                        startIcon={loading || paymentStatus === 'processing' || paymentStatus === 'redirecting' ? null : <PaymentIcon />}
                                        sx={{
                                            minWidth: '200px',
                                            backgroundColor: paymentStatus === 'processing' ? 'warning.main' :
                                                paymentStatus === 'redirecting' ? 'success.main' : 'primary.main'
                                        }}
                                    >
                                        {loading ? 'Connecting to ICICI Gateway...' :
                                            paymentStatus === 'processing' ? 'Processing Payment Request...' :
                                                paymentStatus === 'redirecting' ? 'Redirecting to EasyPay...' :
                                                    `Pay ${formatCurrency(deductTDS ? getFinalAmount() : paymentDetails?.summary?.grandTotal)} via ICICI`
                                        }
                                    </Button>
                                ) : (
                                    <Alert severity="info" sx={{ flexGrow: 1, textAlign: 'left' }}>
                                        <Typography variant="body2" fontWeight="bold">
                                            Offline Payment Selected
                                        </Typography>
                                        <Typography variant="body2">
                                            Use the "Bank Details" button above to get account information, and "Fill Payment Details"
                                            to submit your transaction information after payment.
                                        </Typography>
                                    </Alert>
                                )}
                            </Box>
                        </>
                    )}

                    {activeStep === 2 && renderPaymentConfirmation()}
                </Grid>

                {/* Sidebar with Application Info */}
                <Grid item xs={12} lg={4}>
                    <Card elevation={2}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
                                Application Details
                            </Typography>
                            <Divider sx={{ mb: 2 }} />
                            {/* 
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">Application ID</Typography>
                                <Typography variant="body1" fontWeight="bold">
                                    {paymentDetails?.appId || localStorage.getItem('appId') || ''}
                                </Typography>
                            </Box> */}

                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">Payment Type</Typography>
                                <Typography variant="body1">
                                    {paymentDetails?.paymentTypeDescription || 'Application Fees'}
                                </Typography>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">Laboratory Type</Typography>
                                <Typography variant="body1">
                                    {paymentDetails?.cabType ? `${paymentDetails.cabType} Laboratory` : 'Medical Laboratory'}
                                </Typography>
                            </Box>

                            {paymentDetails?.hasMedicalImaging !== undefined && (
                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="body2" color="text.secondary">Medical Imaging</Typography>
                                    <Chip
                                        label={paymentDetails.hasMedicalImaging ? 'Yes' : 'No'}
                                        color={paymentDetails.hasMedicalImaging ? 'success' : 'default'}
                                        size="small"
                                    />
                                </Box>
                            )}

                            <Box sx={{ mb: 2 }}>
                                <Typography variant="body2" color="text.secondary">Payment Status</Typography>
                                <Chip
                                    label={paymentStatus === 'success' ? 'Paid' : 'Pending'}
                                    color={paymentStatus === 'success' ? 'success' : 'warning'}
                                    size="small"
                                />
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                Need Help?
                            </Typography>
                            <Typography variant="body2">
                                Contact NABL Support at supportwp@nabl.qcin.org or call 011-40032401,011-40032402
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Dialog Components */}
            {renderBankDetailsDialog()}
            {renderOfflinePaymentDialog()}
        </Box>
    );
};

export default PaymentPage;